import { Trans } from '@lingui/macro'
import { Box, styled, Typography } from '@mui/material'
import { PlatformConfigState } from '@om1/platform-config/state'
import { connectRedux, FrameworkComponentProps } from '@om1/platform-utils'
import { FunctionComponent } from 'react'
import LinkinIcon from '../assets/linkedin_2x.png'
import TwitterIcon from '../assets/twitter_2x.png'
const Logo = styled('img')({
    borderRadius: '25px',
    width: '30px',
    height: '30px',
    padding: '3px'
})

export type FooterComponentProps = FrameworkComponentProps<Omit<PlatformConfigState, 'showHelpDialog'>, {}, {}>

export function createFooterComponent<TState extends { platformConfig: PlatformConfigState }>() {
    return connectRedux(FooterComponent, (state: TState) => {
        return { ...state.platformConfig }
    })
}

export type Footer = ReturnType<typeof createFooterComponent>

export const FooterComponent: FunctionComponent<FooterComponentProps> = ({ state, actions, props }) => {
    const copyrightYear = new Date().getFullYear()

    return (
        <Box
            component='footer'
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignContent: 'center',
                alignItems: 'center',
                background: 'white',
                padding: '10px 0px 10px 0px',
                minWidth: 'fit-content'
            }}
        >
            <Typography
                variant='caption'
                color='initial'
                sx={{
                    height: '30px',
                    color: '#555559',
                    fontSize: '14px',
                    letterSpacing: '0',
                    lineHeight: '30px'
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center', minWidth: 'fit-content' }}>
                    <Box sx={{ minWidth: 'fit-content' }}>
                        {copyrightYear} <Trans> © Copyright OM1, All rights reserved.</Trans>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center', minWidth: 'fit-content' }}>
                        <Box
                            sx={{ marginLeft: '10px', marginRight: '10px', color: '#79A6D6', cursor: 'pointer' }}
                            onClick={() => {
                                window.open('https://www.om1.com/privacy/')
                            }}
                        >
                            <Trans>Privacy</Trans>
                        </Box>
                        |
                        <Box
                            sx={{ marginLeft: '10px', marginRight: '10px', color: '#79A6D6', cursor: 'pointer' }}
                            onClick={() => {
                                window.open('https://www.om1.com/terms-of-use/')
                            }}
                        >
                            <Trans>Terms of Use</Trans>
                        </Box>
                        <Logo
                            sx={{ cursor: 'pointer' }}
                            src={LinkinIcon}
                            onClick={() => {
                                window.open('https://www.linkedin.com/company/om1-inc.')
                            }}
                        />
                        <Logo
                            sx={{ cursor: 'pointer' }}
                            src={TwitterIcon}
                            onClick={() => {
                                window.open('https://twitter.com/Om1Inc')
                            }}
                        />
                    </Box>
                </Box>
            </Typography>
        </Box>
    )
}
